/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 8/2/2023
 */

import React, { useState, useEffect } from "react"
import UploadZone from "./UploadZone"
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Divider,
  Alert,
  FormControlLabel,
  Checkbox,
} from "@mui/material"
import GroupsMultiSelect from "../../../components/groupsDropdown/GroupsMultiSelect"
import FormControl from "@mui/material/FormControl"
import OrgsDropdown from "../../../components/orgsDropdown/OrgsDropdown"
import { Tabs, Tab } from "react-bootstrap"
import AssignAPK from "./AssignAPK"
import LoadingButton from "@mui/lab/LoadingButton"
import SaveIcon from "@mui/icons-material/Save"
import CloseIcon from "@mui/icons-material/Close"
import api from "../../../../base/services/ResApi"
import { RequestErrorHandeling } from "../../../../base/errorHandeling/RequestErrorHandeling"
import Alerts from "../../../../base/errorHandeling/Alerts"
import UnassignAPK from "./UnassignAPK"

const ApkUploadModal = ({
  open,
  onClose,
  orgCode,
  grpName,
  grpId,
  defaultTab,
  fromGroup,
}) => {
  //for error handling
  const [iserror, setIserror] = useState(false)
  const [iserrorShow, setIserrorShow] = useState(false)
  const [isUnauhtError, setIsUnauhtError] = useState(false)
  const [errorMessages, setErrorMessages] = useState([])

  const [isSuccess, setIsSuccess] = useState(false)
  const [successMessage, setSuccessMessage] = useState([])

  const [organiCode, setOrganiCode] = useState(orgCode)
  const [isSubmit, setIsSubmit] = useState(false)
  const [isGrpCheckboxChecked, setIsGrpCheckboxChecked] = useState(false)
  const [tabSelect, setTabSelect] = useState()
  const [grpIdList, setGrpIdList] = useState(null)
  const [fromGrpID, setFromGrpID] = useState(null)
  const [appId, setAppId] = useState(null)

  useEffect(() => {
    setOrganiCode(orgCode)
  }, [orgCode])

  //clear all alerts after a timeout
  useEffect(() => {
    if ((iserror || isSuccess) === true) {
      let timerId = setTimeout(() => {
        setSuccessMessage([])
        setIsSuccess(false)
        setIserror(false)
        setErrorMessages([])
        timerId = null
      }, 5000)
      return () => clearTimeout(timerId)
    }
  }, [iserror, isSuccess])

  useEffect(() => {
    if (fromGroup === true) {
      setFromGrpID([grpId])
      setIsGrpCheckboxChecked(true)
    }
  }, [grpId])

  const handleOrgChange = (event) => {
    const value = event?.target?.value
    setOrganiCode(value)
  }
  const handleCheckboxChange = (e) => {
    setIsGrpCheckboxChecked(e.target.checked)
  }

  const handleTabSelect = (k) => {
    setTabSelect(k)
  }

  const handleMultiGrpChange = (e) => {
    const grpList = e.map((g) => g.value)
    setGrpIdList(grpList)
  }
  const handleApkChange = (e) => {
    const apkId = e ? e.applicationId : null
    setAppId(apkId)
  }

  const handleApkAssign = () => {
    setIsSubmit(true)
    const config = {
      headers: {
        "content-type": "multipart/form-data",
        "Accept-Version": "1.0",
        action: "APTG",
      },
    }
    const formData = new FormData()
    const payload = {
      orgCode: organiCode,
      desc: "",
      applicationId: appId,
      linkGrpIdList: fromGroup === true ? fromGrpID : grpIdList,
      unlinkGrpIdList: null,
    }

    const app_detail = new Blob([JSON.stringify(payload)], {
      type: "application/json",
    })
    formData.append("application_details", app_detail)

    api
      .post("/applications", formData, config)
      .then((res) => {
        setErrorMessages([])
        setIserror(false)
        setIsSuccess(true)
        setSuccessMessage([res.data?.description])
        setTimeout(() => {
          setIsSubmit(false)
          setIsSuccess(false)
          setSuccessMessage([""])
          onClose()
        }, 4000)
      })
      .catch((error) => {
        setIsSubmit(false)
        setIsSuccess(false)
         RequestErrorHandeling(
           error,
           setIserror,
           setErrorMessages,
           setIserrorShow,
           setIsUnauhtError
         )
      })
  }

   const handleApkUnassign = () => {
    setIsSubmit(true)
    const config = {
      headers: {
        "content-type": "multipart/form-data",
        "Accept-Version": "1.0",
        action: "APTG",
      },
    }
    const formData = new FormData()
    const payload = {
      orgCode: organiCode,
      desc: "",
      applicationId: appId,
      linkGrpIdList: null,
      unlinkGrpIdList: fromGroup === true ? fromGrpID : grpIdList,
    }

    const app_detail = new Blob([JSON.stringify(payload)], {
      type: "application/json",
    })
    formData.append("application_details", app_detail)

    api
      .post("/applications", formData, config)
      .then((res) => {
        setErrorMessages([])
        setIserror(false)
        setIsSuccess(true)
        setSuccessMessage([res.data?.description])
        setTimeout(() => {
          setIsSubmit(false)
          setIsSuccess(false)
          setSuccessMessage([""])
          onClose()
        }, 4000)
      })
      .catch((error) => {
        setIsSubmit(false)
        setIsSuccess(false)
         RequestErrorHandeling(
           error,
           setIserror,
           setErrorMessages,
           setIserrorShow,
           setIsUnauhtError
         )
      })
  }

  return (
    <div>
      <Dialog
        fullWidth={true}
        maxWidth="true"
        open={open}
        PaperProps={{
          style: { borderRadius: "10px", width: "912px", margin: 0 },
        }}
      >
        <DialogTitle className="apkUploadTitle">
          APK Management
          <IconButton aria-label="cancel" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider sx={{ borderBottomWidth: 5 }} />
        <form>
          <DialogContent
            dividers
            sx={{
              marginTop: 8,
            }}
          >
            <div>
              <Alerts
                iserror={iserror}
                errorMessages={errorMessages}
                isSuccess={isSuccess}
                successMessages={successMessage}
                iserrorShow={iserrorShow}
              />
            </div>
            <FormControl fullWidth>
              <OrgsDropdown
                isRequired={true}
                orgCode={organiCode}
                onChange={handleOrgChange}
                isDisabled={fromGroup}
              />
              <br />
              {fromGroup === false ? (
                <div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isGrpCheckboxChecked}
                        onChange={handleCheckboxChange}
                        color="secondary"
                      />
                    }
                    label="Enable Group Selection"
                  />
                  <GroupsMultiSelect
                    isDisabled={!isGrpCheckboxChecked}
                    orgCode={organiCode}
                    name="groups"
                    onChange={handleMultiGrpChange}
                  />
                </div>
              ) : (
                <div>
                  <TextField
                    fullWidth
                    disabled
                    variant="outlined"
                    name="grpName"
                    label="Group"
                    value={grpName}
                  />
                </div>
              )}
            </FormControl>
            <br />
            <br />
            {/* <Divider>Operations</Divider> */}

            <br />
            <div>
              <Tabs
                defaultActiveKey={defaultTab}
                id="uncontrolled-tab-example"
                className="mb-3"
                fill
                onSelect={handleTabSelect}
              >
                <Tab eventKey="Upload" title="Upload APK">
                  <UploadZone
                    orgCode={organiCode}
                    action={isGrpCheckboxChecked === true ? "UATG" : "UAO"}
                    grpIdList={isGrpCheckboxChecked === true ? grpIdList : null}
                    fromGrpID={fromGrpID}
                    fromGroup={fromGroup}
                  />
                </Tab>
                <Tab eventKey="Assign" title="Assign APK">
                  <AssignAPK
                    orgCode={organiCode}
                    isDisabled={!isGrpCheckboxChecked}
                    apkDropdownOnchange={handleApkChange}
                    handleMultiGrpChange={handleMultiGrpChange}
                    grpId={grpId}
                  />
                </Tab>
                 <Tab eventKey="Unassign" title="Unassign APK">
                  <UnassignAPK
                    orgCode={organiCode}
                    isDisabled={!isGrpCheckboxChecked}
                    apkDropdownOnchange={handleApkChange}
                    handleMultiGrpChange={handleMultiGrpChange}
                    grpId={grpId}
                  />
                </Tab>
              </Tabs>
            </div>
          </DialogContent>
          <DialogActions sx={{ p: "1.25rem" }}>
            {tabSelect === "Assign" && (
              <LoadingButton
                onClick={handleApkAssign}
                color="success"
                loading={isSubmit}
                variant="contained"
                loadingPosition="start"
                startIcon={<SaveIcon />}
              >
                Assign
              </LoadingButton>
            )}
             {tabSelect === "Unassign" && (
              <LoadingButton
                onClick={handleApkUnassign}
                color="success"
                loading={isSubmit}
                variant="contained"
                loadingPosition="start"
                startIcon={<SaveIcon />}
              >
                Unassign
              </LoadingButton>
            )}

            <Button onClick={onClose} variant="outlined" color="error">
              Cancel
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  )
}

export default ApkUploadModal
